module.exports = __webpack_public_path__ + "img/blog-cover-download-without-account.a31d7d9e.webp";